// PGF Scout uses a standalone vanilla-JS artifact UI mounted directly in
// public/index.html. React stays mounted (CRA requirement) but renders nothing
// so it doesn't interfere with the artifact's markup.
function App() {
  return null;
}

export default App;
